// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"modal-wrapper--1KRTr","button":"button--3GEqZ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/ticketingSuggestionModal/ticketingSuggestionModal.scss
// module id = QNPI
// module chunks = 1